import { type OutlookAgentSdxPaneProps } from './components/OutlookAgentSdxPane';
import type * as lazyIndex from './lazyIndex';
import { type LazyComponent, LazyModule, createLazyComponent } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "OutlookAgent" */ './lazyIndex'),
    { name: 'OutlookAgent' }
);

export const OutlookAgentSdxPane: LazyComponent<OutlookAgentSdxPaneProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.OutlookAgentSdxPane);

export type { OutlookAgentSdxPaneProps };

// Non-lazy synchronous routing contract — read by the Copilot pane/header/drawer. Tiny, no side
// effects, safe to export eagerly.
export { isOutlookAgentSdxActive } from './state/outlookAgentMode';
